import { mapActions } from 'vuex';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import seoMetaMixin from '@/mixins/seoMeta';

export default {
  mixins: [
    cmsContentMixin,
    loaderMixin,
    contentLoaderMixin,
    seoMetaMixin,
  ],
  metaInfo() {
    return this.buildSeoMeta({
      title: 'Learn',
    });
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.loaderAdd(document.body);
    this.getStaticPageFull(STATIC_PAGES.LEARN)
      .then((data) => {
        this.isComponentReady = true;
        this.installDynamicControls({ data });
      })
      .then(() => this.loaderRemove(document.body))
      .catch(() => {
        this.isComponentReady = true;
        this.loaderRemove(document.body);
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-learn-stories/page-learn-stories.js